import { useEffect, useState } from 'react';
import type {
  KenhBanHang,
  KenhBanHangHinhThucThanhToan,
  KenhBanHangNguonDon,
  KenhBanHangPhuongThucThanhToan
} from '@/types/schemas';

export const useSearchFieldStates = (initialData?: KenhBanHang | null) => {
  // Nguon don state
  const [nguonDon, setNguonDon] = useState<KenhBanHangNguonDon | null>(initialData?.ma_nguondon_data || null);

  // Hinh thuc thanh toan state
  const [hinhThucThanhToan, setHinhThucThanhToan] = useState<KenhBanHangHinhThucThanhToan | null>(
    initialData?.ma_httt_data || null
  );

  // Phuong thuc thanh toan state
  const [phuongThucThanhToan, setPhuongThucThanhToan] = useState<KenhBanHangPhuongThucThanhToan | null>(
    initialData?.ma_pttt_data || null
  );

  // Reset states when initialData changes
  useEffect(() => {
    setNguonDon(initialData?.ma_nguondon_data || null);
    setHinhThucThanhToan(initialData?.ma_httt_data || null);
    setPhuongThucThanhToan(initialData?.ma_pttt_data || null);
  }, [initialData]);

  return {
    nguonDon,
    setNguonDon,
    hinhThucThanhToan,
    setHinhThucThanhToan,
    phuongThucThanhToan,
    setPhuongThucThanhToan
  };
};
